<ion-header>
  <ion-toolbar>
    <ion-title>Selecteer een productie</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div class="modal-content">
    <div class="show-list">
      @for (show of sortedShows; track show) {
        <button
          (click)="pickShow(show)"
          [class.selected]="isCurrentlyActive(show)"
          [disabled]="isSwitching"
          [style.--accent-color]="show.primaryColor"
          class="show-option"
          type="button"
          data-cy="show-select-item"
          >
          <app-show-avatar
            [imageUrl]="show.imageUrl"
            [showName]="show.name"
            size="small">
          </app-show-avatar>
          <span class="show-option-name">{{ show.name }}</span>
          @if (show.status === 'CONCEPT') {
            <ion-badge
              class="show-option-badge"
              color="medium"
              >
              Concept
            </ion-badge>
          }
          @if (switchingShowId === show.id) {
            <ion-spinner
              class="show-option-check"
              color="primary"
              name="crescent">
            </ion-spinner>
          } @else if (isCurrentlyActive(show)) {
            <ion-icon
              class="show-option-check"
              color="primary"
              name="checkmark-circle"
            ></ion-icon>
          } @else {
            <ion-icon
              class="show-option-check"
              color="medium"
              name="ellipse-outline"
            ></ion-icon>
          }
        </button>
      }
    </div>
  </div>
</ion-content>
